import * as React from "react";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { Typography } from "@mui/material";
import { CmpStatusIcon } from "../../../Component/Common/ToolBox/ToolBox";
export const EasyPutAwayVarianceTblCard = ({ data = [], onClick = () => {} }) => {
  return (
    <Grid container spacing={1} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
        >
          <div className="easy-putaway-card">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                CardID
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.CardID}
                </Typography>
              </Grid>

              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                GRNQty
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.GRNQty}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                PUTAWAYQty
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.PUTAWAYQty}
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography variant="subtitle1" className="value">
                  {item.Name1}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
